import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const menuItems = [
        { name: 'Início', to: 'hero' },
        { name: 'Sobre', to: 'about' },
        { name: 'Portfolio', to: 'portfolio' },
        { name: 'Processo', to: 'process' },
        { name: 'Serviços', to: 'services' },
        { name: 'Contacto', to: 'contact' },
    ];

    return (
        <header className={`map-header ${scrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <div className="logo">
                    <Link to="hero" smooth duration={800} spy>
                        MAPDESIGN
                    </Link>
                </div>

                <button 
                    className="mobile-menu-toggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
                    {menuItems.map((item) => (
                        <Link
                            key={item.to}
                            to={item.to}
                            smooth
                            duration={800}
                            spy
                            activeClass="active"
                            className="nav-link"
                            onClick={() => setMenuOpen(false)}
                        >
                            {item.name}
                        </Link>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Header;
